// Hero.jsx
export default function Hero() {
  return (
    <section id="hero" className="hero">
      <h1>Launching Soon</h1>
      <p>
        Handcrafted embroidery designs that celebrate tradition, patience, and
        artistry.
      </p>
    </section>
  );
}
